import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de565142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "modal-title space-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "클럽딜 참여 정보", -1))
const _hoisted_6 = { class: "wrapper_container" }
const _hoisted_7 = { class: "modal-content" }
const _hoisted_8 = { class: "modal_top" }
const _hoisted_9 = { class: "status_title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 참여 신청한 상태입니다. ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status_info" }, [
  /*#__PURE__*/_createTextVNode(" 참여금 입금을 하시거나, 참여 신청을 취소하셔야"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 새로운 클럽딜 참여가 가능합니다. ")
], -1))
const _hoisted_13 = { class: "content_wrap" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub_title" }, " 입금계좌 ", -1))
const _hoisted_15 = { class: "sub_info" }
const _hoisted_16 = { class: "content_wrap" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub_title" }, " 입금금액 ", -1))
const _hoisted_18 = { class: "sub_info" }
const _hoisted_19 = { class: "content_wrap" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub_title" }, " 입금 가능 기한 ", -1))
const _hoisted_21 = { class: "sub_info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss()))
          }, "닫기")
        ])
      ])
    ]),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.anotherNotYet.partnershipName), 1),
                _hoisted_10,
                _hoisted_11
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.anotherNotYet.bank) + " " + _toDisplayString(_ctx.anotherNotYet.bankno) + " " + _toDisplayString(_ctx.anotherNotYet.bankholder), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$filters.currency(_ctx.anotherNotYet.asset)) + " 원 ", 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.anotherNotYet.createAt), 1)
            ]),
            _createElementVNode("button", {
              class: "cancel_btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'클럽딜 참여 정보', 'clickContent':'참여 취소하기'});_ctx.cancel()})
            }, " 참여 취소하기 ")
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}